import { restRequest } from 'config/rest-client';

export const resetPassword = async (payload: any) => restRequest('/users/reset', {
  method: 'POST',
  body: payload,
});

export default { resetPassword };
